/** The OpsBelt mark — a segmented belt-ring. Inherits color via `currentColor`. */
export function OpsBeltMark({
  size = 28,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <circle
        cx="32"
        cy="32"
        r="22"
        fill="none"
        stroke="currentColor"
        strokeWidth="8.5"
        strokeDasharray="15.5 11.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
